import { Component, OnInit, ViewChild, AfterViewInit, ViewContainerRef, Inject, ElementRef, HostListener } from '@angular/core';
import { commonService } from "../../service/common.service";
import { McqService } from "../../service/mcq.service";
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { QuestionClass } from './question-class';
import { Http, ResponseContentType, Headers } from '@angular/http';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { openClose } from '../../home/studentreport/animation';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Globals } from '../../globals';
import { DOCUMENT } from '@angular/common';
import { ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css', './quizloader.scss'],
  animations: [openClose],
  providers: [McqService],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionsComponent implements OnInit, AfterViewInit {
  modalReference: NgbModalRef;
  isQuestionCardShow: boolean = false;
  totalAnswered: number = 0;
  rightAnswer: number;

  colorReview = [];
  colorSelectedReview = [];
  colorSelected = [];

  seconds: number = 0;//7200+1; //add 1 to show count correct due to loading of view
  interval;
  currentTime: any;
  setPaletteSecond = 0;
  palletecount = 0;
  palletesettime = 0;
  currentSecond1 = 0;
  currentSecond2 = 0;
  private myTemplate: any = "";
  isOpen = true;
  isSubmit = false;
  userData: any;
  paperId: any = 0;
  displayPannelType = 'singleQuestion';
  isTab = false;
  questionIds = [];

  questionObj = new QuestionClass();
  @ViewChild('questionForm') questionForm: any;
  @ViewChild('questionTest') questionTest: any;
  @ViewChild('tabRef') ngbTabSet;
  tabSet: any;
  @ViewChild(NgbTabset) set content(content: ViewContainerRef) {
    this.tabSet = content;
  };
  @ViewChild('numPadnew') keyField: ElementRef;
  public onlineOffline: boolean = navigator.onLine;

  paperData: any;
  sectionNames: any;
  questionList: any;
  sectionWiseData: any = {};
  msg: string = '';
  isError: boolean = false;
  currentTab = 0;
  waitPalleteType = false;
  PalleteTypeCount: any = [];
  elem;
  numPad: any = [];
  cursorPos: any;
  previousTimeArr = [];
  isPostLoad = true;
  s: any = -1;
  path = this.global.quizFolderUrl;
  allQuestionIds = [];

  /*-----------------------*/
  quesInterval: any = 0;
  quesSeconds: any = -1;
  qTime: any = 0;

  objStartTime = 0;
  objEndTime = 0;

  constructor(private httpc: HttpClient, private http: Http, private modalService: NgbModal, private commonService: commonService, private router: Router, private route: ActivatedRoute, private global: Globals, private mcqservice: McqService, @Inject(DOCUMENT) private document: any) {


  }

  answerArray = [];
  currentQuesId = 1;
  currentSecond: any;
  allQuestions: any = [{}];

  ngOnInit() {
    this.elem = document.documentElement;

    window.addEventListener("beforeunload", function (e) {
      e.preventDefault();

    });

    this.commonService.profile.subscribe((data: any) => {
      if (data && Object.keys(data).length != 0) {
        this.userData = data;
        //console.log('user data', this.userData);
      } else {
        this.userData = {};
      }
    });

    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.paperId = parseInt(atob(params['id']));
        if (isNaN(this.paperId)) {
          this.paperId = 0;
          this.router.navigateByUrl('/home');
        }

        if (this.paperId > 0) {
          //console.log('papert id', this.paperId);
          this.getDetailsForStartQuiz();
        }
      }
    });

  }

  // DISABLE ALL KEYBOAR KEYS
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    event.returnValue = false;
    event.preventDefault();
  }

  //DISABLE RIGHT CLICK
  @HostListener('contextmenu', ['$event'])
  onContextmenu(event) {
    //console.log(event);
    event.returnValue = false;
    event.preventDefault();

  }

  //DISABLE RIGHT CLICK
  onRightClick(event: any) {
    return false;
  }

  getDetailsForStartQuiz() {
    let obj = {};
    obj['paperId'] = this.paperId;

    this.mcqservice.getDetailsForStartQuiz(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.questionList.length > 0) {
          this.paperData = data.results.paperData[0];
          //console.log('paper data', this.paperData);
          this.sectionNames = data.results.sectionNames;
          this.questionList = data.results.questionList;

          // SHUFFLE QUESTION ARRAY IF SETTING IS TRUE
          if (this.paperData.shuffleQuestion) {
            this.questionList = this.shuffle(this.questionList);
          }

          if (this.sectionNames.length > 0) this.isTab = true;  // show tab or not

          this.allQuestionIds = [];
          for (let x of this.questionList) {
            this.allQuestionIds.push(x.id);
          }

          this.sectionWiseData = this.getNestedChildren(this.sectionNames, this.questionList); // reset question array on section wise
          this.allQuestions = this.sectionWiseData[this.sectionNames[0].sectionId];// set default question list on first tab
          //this.allQuestions = this.sectionWiseData[Object.keys(this.sectionWiseData)[0]]; 
          this.currentQuesId = this.allQuestions[0].id; // set the first question id on tab change
          this.currentTab = this.sectionNames[0].sectionId; // set 0 index section id as current tab id;

          this.questionIds = [];
          for (let x of this.allQuestions) {
            this.questionIds.push(x.id);
          }

          //SET THE TIMER VALUE
          this.seconds = (this.paperData.totalTime * 60) + 1;
          this.isPostLoad = false;

          //console.log('here', this.paperData, this.sectionNames, this.questionList, this.sectionWiseData);
        } else {
          this.paperData = {};
          this.sectionNames = {};
          this.questionList = {};
          // console.log('here 0', data.results.questionList.length)
        }

        // CHECK IF USER HAS REMAINING ATTEMPT FOR THIS QUIZ
        this.calculateQuizAttempts();

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.msg = "internal server error!";
    });
  }

  getNestedChildren(arr, QL) {
    var out = {};
    for (let i of arr) {
      var subArr = [];
      for (let j of QL) {
        if (j.sectionId == i.sectionId) subArr.push(j);
      }
      out[i.sectionId] = subArr;
    }

    return out;
  }

  // START TIMER AFTER VIEW LOAD
  ngAfterViewInit() {
    this.startTimer();
    this.currentSecond = this.seconds;// set time in seconds.
    this.startQuesTimer(); //start question timer for first question
  }

  //
  getCuurentSecond() {
    return this.seconds;
  }

  // SET START TIME AND END TIME AND CALCULATE THE TOTAL SPENDED TIME OF EACH QUESTION
  calculateSpendedTime(questionTest){
    let questId = (Object.keys(questionTest.value)[0]);
    var result = this.allQuestions.filter(obj => {
      if(obj.id == questId){ //console.log('22222',questId,this.quesSeconds,obj);
        obj.spendedTime = (obj.spendedTime) ? parseInt(obj.spendedTime)+parseInt(this.quesSeconds) : this.quesSeconds;
      } 
    });
    //questionTest.controls['spendedTime' + questId].setValue(spendedTime + Math.abs(diff));
    //console.log('8888888',questId, this.allQuestions);
    this.quesSeconds = 0;
  }


  /*setlastTime(questionTest, questId) {
    let currentSecond = this.seconds;
    questionTest.controls['lastVisitedTime' + questId].setValue(currentSecond);

    setTimeout(() => {
      this.previousTimeArr[this.currentQuesId] = currentSecond;
      if (questionTest.controls['firstVisitedTime' + this.currentQuesId]) {
        questionTest.controls['firstVisitedTime' + this.currentQuesId].setValue(currentSecond);
      } else if (questionTest.value['firstVisitedTime' + questId] && this.questionIds.indexOf(this.currentQuesId) != 1) {
        questionTest.controls['firstVisitedTime' + questId].setValue(currentSecond);
      }
    }, 1000);

    // is question is changed from pallete 
    if (this.setPaletteSecond > 0) {
      questionTest.controls['firstVisitedTime' + questId].setValue(this.setPaletteSecond);
    }

    //console.log('this.setPaletteSecond',this.setPaletteSecond); 

    // set start time to first question only as it works for this. 
    if (typeof (questionTest.value['firstVisitedTime' + questId]) == "undefined" && this.questionIds.indexOf(this.currentQuesId) == 1) {
      let starttime = (this.paperData.totalTime * 60);
      questionTest.controls['firstVisitedTime' + questId].setValue(starttime);
    }

    let a = questionTest.value; 
    //let firstVisitedTime = typeof (a['firstVisitedTime' + questId]) == "undefined" ? this.previousTimeArr[questId] : a['firstVisitedTime' + questId];
    let firstVisitedTime = typeof (this.previousTimeArr[questId]) == "undefined" ? a['firstVisitedTime' + questId] : this.previousTimeArr[questId] ;
    if(typeof (firstVisitedTime) == "undefined"){
      firstVisitedTime = typeof (a['firstVisitedTime' + questId]) == "undefined" ? this.previousTimeArr[questId] : a['firstVisitedTime' + questId];
    }
   
    let lastVisitedTime = a['lastVisitedTime' + questId];
    let spendedTime = !isNaN(Math.floor(a['spendedTime' + questId])) ? Math.floor(a['spendedTime' + questId]) : 0;
    let diff = Math.floor(firstVisitedTime) - Math.floor(lastVisitedTime);

    questionTest.controls['spendedTime' + questId].setValue(spendedTime + Math.abs(diff));

    //reset the pallete seconds value
    this.resetPalleteTime();

    /* save question details on each click
    var result = this.allQuestions.filter(obj => {
      return obj.id == questId
    })
    this.saveAllAnswers(result);
     

     //console.log('time',firstVisitedTime,lastVisitedTime,spendedTime, spendedTime + Math.abs(diff));

  }*/

  // SAVE & NEXT CLICK FUNCTION
  submitTest(questionTest: any) {
    //console.log("222",questionTest.value);
    let questId = (Object.keys(questionTest.value)[0]);
    let ans:any = (Object.values(questionTest.value)[0]);

    /*------------- new question time calculation --------------*
    this.allQuestions.filter(obj => {
      if(obj.id == questId){
        obj.timeTaken = (obj.timeTaken) ? parseInt(obj.timeTaken)+parseInt(this.quesSeconds) : this.quesSeconds;
      } 
    });
    this.quesSeconds = 0;
    /*---------------------------*/

    if (questionTest.value.selectedType == '1') { // set value in case of numeric type questions. 
      ans = parseFloat(ans);
      questionTest.controls[questId].setValue(ans);// avoid error
      
      this.allQuestions.filter(obj => {
        if (obj.id == questId){ 
          if(ans >= obj.ansRangeFrom && ans <= obj.answer){ 
            obj.selected = obj.answer; // ansRangeTo is set as exact answer in mcq_question table so that student ans will exactly match with question correct ans and if true then show student numericValue 
          }
          obj.numericValue = ans;
        } 
      })

    }

    if (typeof (ans) == "undefined" || ans == null) {
      this.colorSelected[questId] = 'notSelected';
    } else {
      this.colorSelected[questId] = 'selected';
    }
    questionTest.controls['selectreview' + questId].setValue('0');
    questionTest.controls['review' + questId].setValue('0');

    if (!this.isSubmit) { //this.getNextKeyId(this.currentQuesId,this.allQuestionIds
      if (this.allQuestionIds[this.allQuestionIds.length] == this.getNextQuestionId(this.currentQuesId, this.allQuestionIds)) {
        document.getElementById("openModalButton").click();
      } else if (this.isTab && this.allQuestions.length == this.getIndexOfK(this.allQuestions, this.currentQuesId)) {
        this.getNextTab();// in case of multiple tabs get the count of last question and open next tab.
      }
      else {
        //  this.currentQuesId = this.currentQuesId+1;
        this.currentQuesId = this.getNextQuestionId(this.currentQuesId, this.questionIds);
      }
    }

    //console.log('ggg xxxxx',this.allQuestions,this.questionIds,this.currentQuesId,this.getIndexOfK(this.allQuestions,this.currentQuesId));

    //this.setlastTime(questionTest, questId);
    this.calculateSpendedTime(questionTest);
    this.palletecount = 0; //reset direct pallete clicks count
  }

  getNextQuestionId(currentQuesId, questionIds) {
    let ci = questionIds.indexOf(currentQuesId);
    //console.log('questionIds',questionIds,currentQuesId,questionIds[ci+1],this.allQuestions);
    return questionIds[ci + 1];
  }

  getNextKeyId(currentQuesId, allQuestionIds) {
    let ci = allQuestionIds.indexOf(currentQuesId);
    return ci + 1;
  }

  getIndexOfK(myArray, k) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].id === k) {
        return i + 1;
      }
    }
  }

  // REVIEW AND NEXT BUTTON FUCTION TO SAVE DATA IN OBJECT 
  reviewAndNext(questionTest: any) {
    //this.quesSeconds = 0; // reset question time
    let questId = (Object.keys(questionTest.value)[0]);
    let ans:any = (Object.values(questionTest.value)[0]);

    if (questionTest.value.selectedType == '1') { // set value in case of numeric type questions. 
      ans = parseFloat(ans);
      questionTest.controls[questId].setValue(ans);// avoid error
      
      this.allQuestions.filter(obj => {
        if (obj.id == questId){ 
          if(ans >= obj.ansRangeFrom && ans <= obj.answer){ 
            obj.selected = obj.answer; // ansRangeTo is set as exact answer in mcq_question table so that student ans will exactly match with question correct ans and if true then show student numericValue 
          }
          obj.numericValue = ans;
        } 
      })

    }

    if (typeof (ans) != "undefined" && ans != null) {
      this.colorSelected[questId] = 'selectreview';
      questionTest.controls['selectreview' + questId].setValue('1');
    } else {
      this.colorSelected[questId] = 'review';
      questionTest.controls['review' + questId].setValue('1');
    }

    //console.log('review',result);
    //console.log('ggg',this.allQuestions);
    //questionTest.controls['2'].reset();
    if (!this.isSubmit) {
      if (this.allQuestionIds[this.allQuestionIds.length] == this.getNextQuestionId(this.currentQuesId, this.allQuestionIds)) {
        document.getElementById("openModalButton").click();
      } else if (this.isTab && this.allQuestions.length == this.getIndexOfK(this.allQuestions, this.currentQuesId)) {
        this.getNextTab();// in case of multiple tabs get the count of last question and open next tab.
      } else {
        //this.currentQuesId = this.currentQuesId+1;
        this.currentQuesId = this.getNextQuestionId(this.currentQuesId, this.questionIds);
      }
    }

    //this.setlastTime(questionTest, questId);
    this.calculateSpendedTime(questionTest);
    //reset direct pallete clicks count
    this.resetPalleteTime();
  }

  paletteSelect(questionTest: any, questId) {
    this.toggle();
    this.setPaletteSecond = this.seconds;
    //this.calculateTimeBetweenTwoSelectivePalletes(1, questionTest);
    this.calculateSpendedTime(questionTest);
    this.currentQuesId = questId;
  }

  /*calculateTimeBetweenTwoSelectivePalletes(palletecount, questionTest) {
    let questId = (Object.keys(questionTest.value)[0]); //to get previous form values
    this.palletecount = palletecount + this.palletecount;

    if ((this.palletecount % 2) == 1) this.currentSecond1 = this.seconds;
    if ((this.palletecount % 2) == 0) this.currentSecond2 = this.seconds;

    // for the first time
    if (typeof (questionTest.value['spendedTime' + questId]) == "undefined" && this.questionIds.indexOf(this.currentQuesId) == 0) {
      let starttime = (this.paperData.totalTime * 60);
      let firstTime = 0;
      firstTime  = Math.floor(starttime - this.seconds);
      questionTest.controls['spendedTime' + questId].setValue(firstTime);
      console.log('first time',questId,starttime,this.seconds,firstTime,firstTime,this.questionIds);
    }

    let a = questionTest.value;
    let spendedTime = !isNaN(Math.floor(a['spendedTime' + questId])) ? Math.floor(a['spendedTime' + questId]) : 0;
    let diff = 0;
    if (this.currentSecond1 > 0 && this.currentSecond2 > 0) {
      diff = Math.floor(this.currentSecond1) - Math.floor(this.currentSecond2);
    }
    questionTest.controls['spendedTime' + questId].setValue(spendedTime + Math.abs(diff));
    // reset starting time of specified question
     this.previousTimeArr[questId] = 0;
    if (questionTest.controls['firstVisitedTime' + questId]) {
        questionTest.controls['firstVisitedTime' + questId].setValue(0);
    }
    if (questionTest.controls['lastVisitedTime' + questId]) {
      questionTest.controls['lastVisitedTime' + questId].setValue(0);
    }
    //console.log('calculateTimeBetweenTwoSelectivePalletes', this.questionTest.value, questId, spendedTime, Math.abs(diff), this.currentSecond1, this.currentSecond2);
  }*/

  // UNSET SELECTED RADIO BUTTON OPTION
  clearAllSelected(questionTest: any) {
    let questId = (Object.keys(questionTest.value)[0]);
    questionTest.controls[questId].reset();
    this.colorSelected[questId] = '';
  }

  resetPalleteTime() {
    this.palletecount = 0;
    this.currentSecond1 = 0;
    this.currentSecond2 = 0;
  }

  //STOP WATCH
  startTimer() {
    this.interval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      }else{
        //AUTO SUBMIT WHEN TIME IS EXCEEDED
        if(!this.isSubmit){
          let element:HTMLElement = document.getElementById('submitQuestion') as HTMLElement;
          element.click();
        }
      }
      let m = Math.floor(this.seconds / 60);
      let rh = Math.floor(m % 60);
      this.currentTime = this.pad(Math.floor(this.seconds / 3600)) + ':' + this.pad(Math.floor(rh)) + ':' + this.pad(Math.floor(this.seconds % 60));
    }, 1000);


  }

  //QUESTION COUNT TIMER
  startQuesTimer() {
    return this.quesInterval = setInterval(() => {
      this.quesSeconds++;
      this.qTime = this.pad(Math.floor(this.quesSeconds));
    }, 1000);
  }

  // ADD PREFIX 0 TO SINLGE DIGIT NUMBER
  pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  // STOP THE TIMER
  pauseTimer() {
    clearInterval(this.interval);
  }

  open2(content) {
    //, closeOnOutsideClick:true
    this.modalReference = this.modalService.open(content, { backdrop: false, windowClass: 'custom-class-abc' });

  }

  d(id: string) {
  }

  open3(content) {
    this.modalReference = this.modalService.open(content, { backdrop: false, windowClass: 'quiz-submit-class' });
  }

  // open next tab
  getNextTab() {
    //let ci = this.sectionNames[this.currentTab+1];
    //this.ngbTabSet.select('section'+ci.sectionId);
    let ci = 0;
    if (this.currentTab != -1) ci = this.getIndexOfTab(this.sectionNames, this.currentTab);
    //console.log('tab sss', this.currentTab, ci, this.sectionNames);
    this.ngbTabSet.select('section' + this.sectionNames[ci].sectionId);
  }

  getIndexOfTab(myArray, k) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].sectionId === k) {
        return i + 1;
      }
    }
  }

  //  tabs has nextId that you can check to invoke the desired function
  fetchNews(evt: any) {
    var nextId = parseInt(evt.nextId.match(/\d+/), 10);
    var activeId = parseInt(evt.activeId.match(/\d+/), 10);

    if (!isNaN(activeId)) {
      this.sectionWiseData[activeId] = this.allQuestions; // reset the object array to hold the current tab changes

      if (!isNaN(nextId)) {
        this.allQuestions = this.sectionWiseData[nextId];
        this.currentQuesId = this.allQuestions[0].id; // set the first question id on tab change
        this.questionIds = [];
        for (let x of this.allQuestions) {
          this.questionIds.push(x.id);
        }
        // console.log(evt, nextId, this.currentQuesId, this.sectionWiseData[nextId]);
      }

      this.currentTab = nextId; // nextId-1; //set newly active tab section id.
    }
  }

  confirmOk(str, questionTest: any) {
    if (str == 'ok') {
      this.isSubmit = true;
      this.pauseTimer();
clearInterval(this.quesInterval);
      this.submitTest(questionTest);

      setTimeout(() => {
        var finalArrQuest = [];
        Object.keys(this.sectionWiseData).forEach(key => {
          Array.prototype.push.apply(finalArrQuest, this.sectionWiseData[key]);
        });
        //console.log('final submit', finalArrQuest);

        this.saveAllAnswers(finalArrQuest);
      }, 2000);

    }
    this.modalReference.close();
  }

  hostReachable() {
    return window.navigator.onLine;
    /*var xhr = new (XMLHttpRequest);
    if(xhr){
      xhr.open( "HEAD", "//" + window.location.hostname + ":4200/?rand=" + Math.floor((1 + Math.random()) * 0x10000), false );
      try {
        xhr.send();
        return ( xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304) );
      } catch (error) {
        return false;
      }
    }else{
      return window.navigator.onLine;
    }*/
  }

  // ON CLICK OF SUBMIT SAVE THE ALL ANSWERS OF THE STUDENT
  async saveAllAnswers(data: any) {
    //console.log('onlineOffline',this.hostReachable());
    if (this.hostReachable()) {
      let obj = {};
      obj['paperId'] = this.paperId;
      obj['studentId'] = this.userData.id;
      obj['data'] = data;//this.allQuestions;
      //HAVE A ENTRY OF EACH ATTEMPT
      await this.updateAttemptCount(this.userData.id, this.paperId);
      //this.router.navigateByUrl('onlineMCQ/quickreport/'+btoa(this.paperId));
      this.mcqservice.saveStudentAnswersAll(obj).subscribe((data: any) => {
        if (data.error == 0) {
          this.router.navigateByUrl('onlineMCQ/online/quickreport/' + btoa(this.paperId));
        } else {
          alert('Some thing went wrong. Plaese try again!');
        }
      });
    } else {
      alert('Internet connection failed!');
      this.isSubmit = false;
    }
  }


  updateAttemptCount(stdid, pid) {
    let obj = {};
    obj['testPaperId'] = pid;
    obj['studentId'] = stdid;
    obj['attemptDate'] = new Date();
    return this.httpc.post(this.global.siteUrl + 'mcq/addattempt', obj).toPromise();
  }

  // SAVE ANSWERS OF EACH QUESTION ONE BY ONE
  /*saveAllAnswers(data:any){
    console.log('question',data[0]);
    if(data[0]){
      let obj = {};
      obj['paperId'] = this.paperId;
      obj['studentId'] = this.userData.id;
      obj['questionId'] = data[0].id;
      obj['data'] = data[0];
      this.mcqservice.saveStudentAnswers(obj).subscribe((data:any)=>{

      });
   }
  }
  
  */

  // ASK FOR RESTART THE QUESTION AT THE END OF.
  confirmRestart(str) {
    if (str == 'ok') {
      this.currentTab = -1; // set to first tab
      this.getNextTab();
      this.allQuestions = this.sectionWiseData[this.sectionNames[0].sectionId];//this.sectionWiseData[Object.keys(this.sectionWiseData)[0]]; // set default question list on first tab
      this.currentQuesId = this.allQuestions[0].id; // set the first question id on tab change
    }
    this.modalReference.close();
  }


  // USE FOR QUESTION ANIMATION SLIDE
  toggle() {
    this.isOpen = !this.isOpen;
  }

  //  GET POP UP COUNT OF ALL TYPE OF PALLETE
  getQuestionTypecount(sectionId) {
    if (this.s != sectionId) {
      this.PalleteTypeCount = [];
      this.s = sectionId;
    }
    // if(this.waitPalleteType==false || this.PalleteTypeCount.length==0){
    let allQuest = this.sectionWiseData[sectionId];
    var type = [];
    type['selectreview'] = 0; type['selected'] = 0; type['review'] = 0; type['leave'] = 0; type['nothing'] = 0;
    //setTimeout(()=>{
    for (let i of allQuest) {
      if (i.selectreview > '0' && i.selected > '0') {
        type['selectreview'] += 1;
      } else if (i.selectreview == '0' && i.selected > '0') {
        type['selected'] += 1;
      } else if (i.review > '0') {
        type['review'] += 1;
      } else if (i.selectreview == '0' && i.review == '0') {
        type['leave'] += 1;
      } else {
        type['nothing'] += 1;
      }
    }
    this.PalleteTypeCount = type;
    //console.log(allQuest);
    this.waitPalleteType = false;
    //},2000);
    //}
    this.waitPalleteType = true;
    //console.log(1);
  }



  // SET THE PROFILE IMAGE OF STUDENT
  profileImage(img) {
    let photo = img;
    if (photo == '') {
      photo = "avatar.png";
    } if (!photo) {

    }
    let res = this.global.profileUrl + photo;
    return res;
  }

  // DISABLE THE RADIO BUTTON OF ALL QUETIONS IF NO TIME LEFT
  isDisabled() {
    return false;
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  numPadKeyup(event: any) {
    this.cursorPos = event.target.selectionStart;
  }

  numPadKeydown(e: any) {
    var key = e.charCode || e.keyCode;
    if (key == 8) {
      // backspace key do nothing
    } else {
      e.preventDefault();
    }
  }

  setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(1, 1);
      //console.log(selectionEnd);
    }
    else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd('character', selectionEnd);
      range.moveStart('character', selectionStart);
      range.select();
    }
  }

  calPad(v, id) {

    if (!this.numPad[id]) this.numPad[id] = '';

    //console.log('dfdfdf',this.cursorPos);
    this.keyField.nativeElement.focus();

    switch (v) {
      case 'backSpace':
        this.numPad[id] = this.numPad[id].substring(0, this.cursorPos - 1) + this.numPad[id].substring(this.cursorPos, this.numPad[id].length);
        break;
      case 'leftArrow':
        setTimeout(() => {
          this.cursorPos = this.cursorPos - 1;
          this.keyField.nativeElement.selectionStart = this.cursorPos;
          this.keyField.nativeElement.selectionEnd = this.cursorPos;
        });
        break;
      case 'rightArrow':
        setTimeout(() => {
          this.cursorPos = this.cursorPos + 1;
          this.keyField.nativeElement.selectionStart = this.cursorPos;
          this.keyField.nativeElement.selectionEnd = this.cursorPos;
        });
        break;
      case 'clearAll':
        this.numPad[id] = '';
        break;
      default:
        this.numPad[id] = [this.numPad[id].slice(0, this.cursorPos), v, this.numPad[id].slice(this.cursorPos)].join(''); //this.numPad+v;
        setTimeout(() => {
          this.keyField.nativeElement.selectionStart = this.cursorPos + 1;
          this.keyField.nativeElement.selectionEnd = this.cursorPos + 1;
        });
        break;
    }



  }

  // shuffle question array on setting basis
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  // get quiz count for sttudent
  calculateQuizAttempts() { //streamlist
    let obj = {};
    obj['paperId'] = this.paperId;
    obj['studentId'] = this.userData.id;
    this.mcqservice.getStudentAttempt(obj).subscribe((data: any) => {
      if (data.error == 0) {
        if (parseInt(data.results) >= parseInt(this.paperData.attemptCount)) {
          alert('attempt exceeded ! ');
          this.router.navigate(['/']);
        }
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
      });
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/questions/questions.component.ts